import { useMutation } from '@tanstack/react-query';
import { createUser } from '../services/api';

interface CreateUserParams {
    email: string;
    password?: string;
    deviceId: string;
    deviceCode: string;
    socialProfile?: any;
    socialProvider?: string;
    socialCode?: string;
    socialTicket?: string; // V2 uses ticket instead of code
    socialOid?: string; // Apple user ID for SocialProfile creation
    firstName?: string;
    lastName?: string;
}

export function useCreateUser() {
    return useMutation({
        mutationFn: async (params: CreateUserParams) => {
            const response = await createUser(params);

            // Don't throw errors - return the response as-is
            // The component will check for success/error
            return response;
        },
        // Don't use error boundaries, let components handle errors
        throwOnError: false,
        // Add retry: false to prevent React Query from retrying expected errors
        retry: false,
    });
}
